module.exports = __webpack_public_path__ + "img/title2-zh.451e97df.png";